import { Opacity } from "@mui/icons-material";
import { createTheme } from "@mui/material/styles";

const themeParcoursup = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "rgba(255,255,255,.6)",

          "&.Mui-focused": {
            color: "#fff",
          },
        },
      },
    },

    MuiOutlinedInput: { 
      styleOverrides: {
        root: {
          color: "#fff",
          background:'rgba(255,255,255,.1)',

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.5)",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fff",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fff",
          },
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "rgba(255,255,255,0.7)",
        },
      },
    },

    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "rgba(255,255,255,.6)",
        }
      },
    },

    MuiTypography: {
      styleOverrides: {
        root: {
          color: "rgba(255,255,255,.6)",

          "& a": {
            color: "#fff",   
            textDecorationColor: '#fff'
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          color: "#1C1AAC",   
          background: "#fff",       
          fontWeight: 700,
          fontSize: 16,
          textTransform: 'none',
          boxShadow:'none',
          width: '100%',

          "&:hover": {
            background: "#4090FF",    
            color: "#fff",
            boxShadow:'none',
          },

          "& .MuiSvgIcon-root": {
            color: "#1C1AAC",   
          },

          "&:hover .MuiSvgIcon-root": {
            color: "#fff",   
          },
        }
      },
    },

    MuiAlert : {
      styleOverrides: {
        root: {
          "& .MuiTypography-root": {
            color:"rgba(0, 0, 0, 0.87)",
          },

          "& .MuiSvgIcon-root": {
            color:"rgba(0, 0, 0, 0.87)",
          },
        },
      },
    }
  },
});

export default themeParcoursup;